import React from "react";
import {
  BASE_URL,
  XCHANGE_PLATFORM_NAME,
  MEETING_SUITE_NAME,
  APP_EVENT_ID,
  APP_EVENT_NAME,
  APP_EVENT_SUMMIT_URL,
  APP_BRAND_NAME,
  APP_BRAND_CONTACT_EMAIL_ADDR,
  BRAND,
  SIDENAV_PEOPLE_LABEL
} from "../utils/consts";

const SideNav = (props) => {
  const { collapsed, toggleCollapse, userProfile, companyId } = props;
  const userCompanyProfileId =
    userProfile?.ExhibitorInformation?.CompanyProfileID;

  return (
    <div className="collapseSidebar flex-shrink-0">
      <div className="headerCollapseOpenSidebar">
        <input
          type="checkbox"
          className="navigation__checkbox"
          id="navi-toggle"
          onChange={() => toggleCollapse((prev) => !prev)}
          checked={!collapsed}
        />

        <label htmlFor="navi-toggle" className="navigation__button">
          <span className="navigation__icon">&nbsp;</span>
        </label>
      </div>
      <nav className="sidebar pageNav" role="navigation">
        <ul id="sidebarOpenNav">
          <li>
            <a href={`${BASE_URL}/${XCHANGE_PLATFORM_NAME}/main/dashboard/`}>
              <i className="fas fa-home"></i>
              <span>Home</span>
            </a>
          </li>
          {APP_BRAND_NAME !== BRAND.BANFF && (
            <React.Fragment>
              <li>
                <a href={`${BASE_URL}/${XCHANGE_PLATFORM_NAME}/main/people/`}>
                  <i className="fas fa-user-friends"></i>
                  {SIDENAV_PEOPLE_LABEL !== undefined ?
                    <span>{SIDENAV_PEOPLE_LABEL}</span> : <span>PEOPLE</span>
                  }
                </a>
              </li>
            </React.Fragment>
          )}
          {APP_BRAND_NAME !== BRAND.BANFF && APP_BRAND_NAME !== BRAND.CIX && (          
            <React.Fragment>
            <li>
                <a href={`${BASE_URL}/${XCHANGE_PLATFORM_NAME}/main/projects/`}>
                  <i className="fas fa-film"></i>
                  <span>Projects</span>
                </a>
              </li>
            </React.Fragment>            
          )}
          <li className="active">
            <div role="button" className="eventSidebarSubMenu">
              <i className="ArrowSubEventItemID-12 pull-right expendarrowfold fas fa-angle-down"></i>
              <img
                className="eventCollapseSideMenu"
                src="/img/icons/conferenceicon.png"
                alt={APP_EVENT_NAME}
              />
              <span>{APP_EVENT_NAME}</span>
            </div>
            <ul className="SubEventItemID-12">
              {APP_BRAND_NAME === BRAND.KID_SCREEN && (
                <>
                  <li>
                    <a
                      href={`${BASE_URL}/${XCHANGE_PLATFORM_NAME}/${APP_EVENT_ID}/marketplace/`}
                    >
                      <span>Event Home</span>
                    </a>
                  </li>
                  <li>
                    <a
                      href={`${BASE_URL}/${XCHANGE_PLATFORM_NAME}/${APP_EVENT_ID}/calendar/`}
                    >
                      <span>Calendar</span>
                    </a>
                  </li>
                  <li>
                    <a
                      href={`${BASE_URL}/${XCHANGE_PLATFORM_NAME}/${APP_EVENT_ID}/messaginghub/`}
                    >
                      <span>Messages</span>
                    </a>
                  </li>
                  <li>
                    <a
                      href={`${BASE_URL}/${XCHANGE_PLATFORM_NAME}/${APP_EVENT_ID}/people/`}
                    >
                      <span>Delegates</span>
                    </a>
                  </li>
                  <li>
                    <a href={`https://${APP_EVENT_SUMMIT_URL}/2021/agenda/`}>
                      <span>Agenda</span>
                    </a>
                  </li>
                  <li>
                    <a href={`https://${APP_EVENT_SUMMIT_URL}/2021/speakers/`}>
                      <span>Speakers</span>
                    </a>
                  </li>
                  <li>
                    <a
                      href={`${BASE_URL}/${XCHANGE_PLATFORM_NAME}/${APP_EVENT_ID}/companyprofiles/directory`}
                    >
                      <span>Exhibitors</span>
                    </a>
                  </li>
                  <li className="active">
                    <a
                      href={`/${
                        userCompanyProfileId ? userCompanyProfileId : companyId
                      }/home`}
                    >
                      <span>Meeting Suite</span>
                    </a>
                  </li>
                  <li>
                    <a
                      href={`${BASE_URL}/${XCHANGE_PLATFORM_NAME}/${APP_EVENT_ID}/projects/`}
                    >
                      <span>Screening</span>
                    </a>
                  </li>
                  <li>
                    <a
                      href={`https://${APP_EVENT_SUMMIT_URL}/2021/faq/#faq-q9`}
                    >
                      <span>FAQ</span>
                    </a>
                  </li>
                </>
              )}

              {APP_BRAND_NAME === BRAND.REAL_SCREEN && (
                <>
                  <li>
                    <a href={`${BASE_URL}/${APP_EVENT_ID}/dashboard/`}>
                      <span>Event Home</span>
                    </a>
                  </li>
                  <li>
                    <a href={`https://${APP_EVENT_SUMMIT_URL}/2021/agenda/`}>
                      <span>Agenda</span>
                    </a>
                  </li>
                  <li>
                    <a
                      href={`${BASE_URL}/${XCHANGE_PLATFORM_NAME}/${APP_EVENT_ID}/calendar/`}
                    >
                      <span>Calendar</span>
                    </a>
                  </li>
                  <li>
                    <a
                      href={`${BASE_URL}/${XCHANGE_PLATFORM_NAME}/${APP_EVENT_ID}/messaginghub/`}
                    >
                      <span>Messages</span>
                    </a>
                  </li>
                  <li>
                    <a
                      href={`${BASE_URL}/${XCHANGE_PLATFORM_NAME}/${APP_EVENT_ID}/projects/`}
                    >
                      <span>Screening</span>
                    </a>
                  </li>
                  <li>
                    <a href={`https://${APP_EVENT_SUMMIT_URL}/2021/speakers/`}>
                      <span>Speakers</span>
                    </a>
                  </li>
                  <li>
                    <a
                      href={`${BASE_URL}/${XCHANGE_PLATFORM_NAME}/${APP_EVENT_ID}/people/`}
                    >
                      <span>Delegates</span>
                    </a>
                  </li>
                  <li>
                    <a
                      href={`${BASE_URL}/${XCHANGE_PLATFORM_NAME}/${APP_EVENT_ID}/companyprofiles/directory`}
                    >
                      <span>Exhibitors</span>
                    </a>
                  </li>
                  <li>
                    <a
                      href={`https://${APP_EVENT_SUMMIT_URL}/2021/faq/#faq-q9`}
                    >
                      <span>FAQ</span>
                    </a>
                  </li>
                  <li className="active">
                    <a
                      href={`/${
                        userCompanyProfileId ? userCompanyProfileId : companyId
                      }/home`}
                    >
                      <span>Meeting Suite</span>
                    </a>
                  </li>
                </>
              )}

              {APP_BRAND_NAME === BRAND.BANFF && (
                <>
                  <li>
                    <a href={`${BASE_URL}/${APP_EVENT_ID}/dashboard/`}>
                      <span>Event Home</span>
                    </a>
                  </li>
                  <li>
                    <a href={`https://${APP_EVENT_SUMMIT_URL}/2021/agenda/`}>
                      <span>Agenda</span>
                    </a>
                  </li>
                  <li>
                    <a
                      href={`${BASE_URL}/${XCHANGE_PLATFORM_NAME}/${APP_EVENT_ID}/calendar/`}
                    >
                      <span>Calendar</span>
                    </a>
                  </li>
                  <li>
                    <a
                      href={`${BASE_URL}/${XCHANGE_PLATFORM_NAME}/${APP_EVENT_ID}/messaginghub/`}
                    >
                      <span>Messages</span>
                    </a>
                  </li>
                  <li>
                    <a
                      href={`${BASE_URL}/${XCHANGE_PLATFORM_NAME}/${APP_EVENT_ID}/projects/`}
                    >
                      <span>Project Lounge</span>
                    </a>
                  </li>
                  <li>
                    <a href={`https://${APP_EVENT_SUMMIT_URL}/2021/speakers/`}>
                      <span>Speakers</span>
                    </a>
                  </li>
                  <li>
                    <a
                      href={`${BASE_URL}/${XCHANGE_PLATFORM_NAME}/${APP_EVENT_ID}/people/`}
                    >
                      <span>Delegates</span>
                    </a>
                  </li>
                  <li>
                    <a
                      href={`${BASE_URL}/${XCHANGE_PLATFORM_NAME}/${APP_EVENT_ID}/companyprofiles/directory`}
                    >
                      <span>Spark Suites</span>
                    </a>
                  </li>
                  <li className="active">
                    <a
                      href={`/${
                        userCompanyProfileId ? userCompanyProfileId : companyId
                      }/home`}
                    >
                      <span>{`${MEETING_SUITE_NAME}`}</span>
                    </a>
                  </li>
                  <li>
                    <a href={`mailto:${APP_BRAND_CONTACT_EMAIL_ADDR}`}>
                      <span>Contact Us</span>
                    </a>
                  </li>
                </>
              )}

              {APP_BRAND_NAME === BRAND.CIX && (
                <>
                  <li>
                    <a href={`${BASE_URL}/${APP_EVENT_ID}/dashboard/`}>
                      <span>Event News</span>
                    </a>
                  </li>
                  <li>
                    <a href={`https://${APP_EVENT_SUMMIT_URL}/2021/agenda/`}>
                      <span>Agenda</span>
                    </a>
                  </li>
                  <li>
                    <a
                      href={`${BASE_URL}/${XCHANGE_PLATFORM_NAME}/${APP_EVENT_ID}/people/`}
                    >
                      <span>Delegates</span>
                    </a>
                  </li>
                  <li>
                    <a
                      href={`${BASE_URL}/${XCHANGE_PLATFORM_NAME}/${APP_EVENT_ID}/messaginghub/`}
                    >
                      <span>Messages</span>
                    </a>
                  </li>
                  <li>
                    <a
                      href={`${BASE_URL}/${XCHANGE_PLATFORM_NAME}/${APP_EVENT_ID}/calendar/`}
                    >
                      <span>My Calendar</span>
                    </a>
                  </li>
                  <li>
                    <a href={`https://${APP_EVENT_SUMMIT_URL}/2021/speakers/`}>
                      <span>Speakers</span>
                    </a>
                  </li>
                  <li>
                    <a href={`https://${APP_EVENT_SUMMIT_URL}/2021/buyerprofiles/`}>
                      <span>Meeting Xchange Hosts</span>
                    </a>
                  </li>
                  <li>
                    <a
                      href={`${BASE_URL}/${XCHANGE_PLATFORM_NAME}/${APP_EVENT_ID}/companyprofiles/directory`}
                    >
                      <span>Exhibitors</span>
                    </a>
                  </li>
                  <li>
                    <a
                      href={`https://${APP_EVENT_SUMMIT_URL}/2021/faq/`}
                    >
                      <span>FAQ</span>
                    </a>
                  </li>                  <li>
                    <a href={`mailto:${APP_BRAND_CONTACT_EMAIL_ADDR}`}>
                      <span>Contact Us</span>
                    </a>
                  </li>
                </>
              )}
            </ul>
          </li>
        </ul>

        <ul id="sidebarCloseNav">
          <li>
            <a href={`${BASE_URL}/${XCHANGE_PLATFORM_NAME}/main/dashboard/`}>
              <i className="fas fa-home"></i>
              <span>Home</span>
            </a>
          </li>
          {APP_BRAND_NAME !== BRAND.BANFF && (
            <React.Fragment>
              <li>
                <a href={`${BASE_URL}/${XCHANGE_PLATFORM_NAME}/main/people/`}>
                  <i className="fas fa-user-friends"></i>
                  {SIDENAV_PEOPLE_LABEL !== undefined ?
                    <span>{SIDENAV_PEOPLE_LABEL}</span> : <span>PEOPLE</span>
                  }
                </a>
              </li>
            </React.Fragment>
          )}
          {APP_BRAND_NAME !== BRAND.BANFF && APP_BRAND_NAME !== BRAND.CIX && (
            <React.Fragment>
              <li>
                <a href={`${BASE_URL}/${XCHANGE_PLATFORM_NAME}/main/projects/`}>
                  <i className="fas fa-film"></i>
                  <span>Projects</span>
                </a>
              </li>
            </React.Fragment>
          )}
          <li className="active">
            <div
              role="button"
              className="eventSidebarSubMenu"
              onClick={() => toggleCollapse((prev) => !prev)}
            >
              <i className="ArrowSubEventItemID-12 pull-right expendarrowfold fas fa-angle-down"></i>
              <img
                className="eventCollapseSideMenu"
                src="/img/icons/conferenceicon.png"
                alt={APP_EVENT_NAME}
              />
              <span>{APP_EVENT_NAME}</span>
            </div>
          </li>
        </ul>
      </nav>
    </div>
  );
};

export default SideNav;
